import { invokeRPC } from './socket.js'

export function getPowerpointSavedReportByProjectAndUserId(data) {
  return invokeRPC('powerpointSavedReports', 'getPowerpointSavedReportByProjectAndUserId', data)
}
